<template>
  <div>
    <loading-spinner :loading-status="loadingStatus" />
    <div v-if="campaigns && !loadingStatus">
      <div class="row mx-0">
        <ejs-grid
          id="templateDetailsCampaignsGrid"
          ref="grid"
          class="cendyn-grid sortingenabled"
          :allow-paging="true"
          :allow-filtering="true"
          :page-settings="pageSettings"
          :filter-settings="filterOptions"
          :allow-sorting="true"
          :sort-settings="sortOptions"
          :data-source="campaigns"
          :data-bound="dataBound"
          :action-begin="actionBegin"
          :action-complete="actionComplete"
          clip-mode="EllipsisWithTooltip"
        >
          <e-columns>
            <e-column
              field="projectId"
              header-text="ID"
              width="120"
              type="String"
              :template="idTemplate"
              :filter="customFilter"
            />
            <e-column
              field="title"
              header-text="Name/Subject"
              :template="nameTemplate"
              :filter="customFilter"
            />
            <e-column
              field="subject"
              header-text="Subject"
              :visible="false"
            />
            <e-column
              field="emailTypeName"
              header-text="Email Type"
            />
            <e-column
              field="statusCampaignTranslated"
              header-text="Status"
              width="200"
              :template="statusTemplate"
              :filter="statusFilter"
            />
            <e-column
              field="updateDate"
              header-text="Updated"
              :sort-comparer="sortComparer"
              :template="updatedTemplate"
              :filter="customFilter"
            />
            <e-column
              field=" "
              header-text=""
              :allow-filtering="false"
              :allow-sorting="false"
              width="40"
            />
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import LoadingSpinner from '@/components/LoadingSpinner'
import { GridId, GridNameSubject, GridCampaignStatus, GridCampaignUpdated } from '@/components/Grid'
import { DataManager, JsonAdaptor, Predicate } from '@syncfusion/ej2-data'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'
import { Page, Sort, Filter, GridPlugin } from '@syncfusion/ej2-vue-grids'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import moment from 'moment'

MultiSelect.Inject(CheckBoxSelection)
Vue.use(GridPlugin)

class SerialNoAdaptor extends JsonAdaptor {
  onWhere (datamanger, e) {
    if (!datamanger || !datamanger.length) {
      return datamanger
    }
    let updateDatePredicate = null
    if (e.predicates) {
      const titlePredicate = e.predicates.find((el) => el.field === 'title')
      const titlePredicateIndex = e.predicates.findIndex(
        (el) => el.field === 'title'
      )
      if (titlePredicate) {
        const newTitlePredicate = new Predicate()
        const subjectPredicate = new Predicate(
          'subject',
          titlePredicate.operator,
          titlePredicate.value
        )
        subjectPredicate.ignoreAccent = false
        subjectPredicate.ignoreCase = true
        newTitlePredicate.condition = 'or'
        newTitlePredicate.predicates = [subjectPredicate, titlePredicate]
        newTitlePredicate.ignoreAccent = false
        newTitlePredicate.isComplex = true
        e.predicates[titlePredicateIndex] = newTitlePredicate
      }

      updateDatePredicate = e.predicates.find(
        (el) => el.field === 'updateDate'
      )
      const updateDatePredicateIndex = e.predicates.findIndex(
        (el) => el.field === 'updateDate'
      )
      if (updateDatePredicate) {
        const newDatePredicate = new Predicate()
        const updatedByPredicate = new Predicate(
          'updatedBy',
          updateDatePredicate.operator,
          updateDatePredicate.value
        )
        updatedByPredicate.ignoreAccent = false
        updatedByPredicate.ignoreCase = true
        newDatePredicate.condition = 'or'
        newDatePredicate.predicates = [updatedByPredicate, updateDatePredicate]
        newDatePredicate.ignoreAccent = false
        newDatePredicate.isComplex = true
        e.predicates[updateDatePredicateIndex] = newDatePredicate
      }
    }

    return datamanger.filter(function (obj) {
      return e.validate(obj)
    })
  }
}

export default {
  components: {
    LoadingSpinner
  },
  mixins: [iframeParentCommunication],
  provide: {
    grid: [Page, Sort, Filter]
  },
  data () {
    return {
      pageSettings: { pageCount: 5, pageSize: 10, pageSizes: ['10', '25', '50', '100'] },
      sortOptions: { columns: [{ field: 'updateDate', direction: 'Descending' }] },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      filters: [],
      gridInitLoad: true,
      gridLoaded: false,
      customFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
          },
          write: (args) => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: (args) => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      statusFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            if (args.target.parentElement.children) {
              args.target.parentElement.children[0].style.display = 'none'
              args.target.parentElement.children[1].style.paddingTop = '0px'
            }
            this.dropInstance = new MultiSelect({
              dataSource: [
                { statusCampaignTranslated: 'Approved' },
                { statusCampaignTranslated: 'Draft' },
                { statusCampaignTranslated: 'Pending' },
                { statusCampaignTranslated: 'Rejected' },
                { statusCampaignTranslated: 'Scheduled Active' },
                { statusCampaignTranslated: 'Scheduled Inactive' },
                { statusCampaignTranslated: 'Testing' }
              ],
              fields: {
                text: 'statusCampaignTranslated',
                value: 'statusCampaignTranslated'
              },
              placeholder: 'Select a value',
              popupHeight: '200px',
              mode: 'CheckBox'
            })
            this.dropInstance.value = this.dropInstance.value || []
            this.dropInstance.appendTo(flValInput)
          },
          write: (args) => {
            let arr = []
            if (
              args.parent.filterModule.actualPredicate
                .statusCampaignTranslated !== undefined
            ) {
              arr = args.parent.filterModule.actualPredicate.statusCampaignTranslated.map(
                (element) => element.value
              )
            }
            this.dropInstance.value = Array.isArray(args.filteredValue)
              ? args.filteredValue
              : arr
          },
          read: (args) => {
            args.fltrObj.filterSettings.columns = args.fltrObj.filterSettings.columns.filter(
              (x) => x.field !== args.column.field
            )
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value
            )
          }
        }
      },
      idTemplate () {
        return {
          template: {
            extends: GridId
          }
        }
      },
      nameTemplate () {
        return {
          template: {
            extends: GridNameSubject
          }
        }
      },
      statusTemplate () {
        return {
          template: {
            extends: GridCampaignStatus
          }
        }
      },
      updatedTemplate () {
        return {
          template: {
            extends: GridCampaignUpdated
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      template: state => state.templateBuilder.template.summary.template ?? {},
      campaigns: state => {
        return new DataManager({
          json: state.templateBuilder.template.campaigns,
          adaptor: new SerialNoAdaptor()
        })
      },
      dynamicQuery: state => state.templateBuilder.template.dynamicQuery,
      accountId: state => state.templateBuilder.accountId
    }),
    loadingStatus () {
      return this.$store.getters.getLoadingStatusItem('set_template_campaigns')
    }
  },
  watch: {
    accountId () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const externalId = this.$route.query.externalId
      const clientId = this.$route.query.clientId
      const templateId = this.$route.query.templateId
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : null

      if (this.accountId && clientId && userEmail) {
        if (Object.keys(this.template).length === 0) {
          this.$store.dispatch('setTemplateSummary', { templateId, userEmail, showLoading: false })
        }
        this.$store.dispatch('setTemplateCampaigns', { clientId, companyId: externalId, isPrimary: true, userEmail })
      }
      this.$helpers.setTableId('templateDetailsCampaignsGrid')
      this.$helpers.setEjsPager('templateDetailsCampaignsGrid')
    },
    dataBound () {
      this.$refs.grid.hideSpinner()
      this.formatPagination()
    },
    colorFilteredColumns () {
      this.filters = this.$refs.grid.ej2Instances.filterSettings.columns
      if (this.filters) {
        const that = this
        this.$refs.grid.ej2Instances.columns = this.$refs.grid.ej2Instances.columns.map(column => {
          if (that.filters.find(filter => filter.field === column.field)) {
            column.customAttributes = { class: 'filtered' }
          } else if (column.customAttributes) {
            delete column.customAttributes
          }
          return column
        })
      }
    },
    formatPagination () {
      // Timeout is to avoid conflict with the component re-rendering
      setTimeout(() => {
        const pageNo = document.getElementsByClassName('e-pagenomsg')
        const pageCount = document.getElementsByClassName('e-pagecountmsg')
        if (pageNo[0] && pageCount[0]) {
          pageNo[0].innerHTML = this.$helpers.numberFormat(pageNo[0].innerHTML)
          pageCount[0].innerHTML = this.$helpers.numberFormat(pageCount[0].innerHTML)
        }
      }, 10)
    },
    sortComparer (reference, comparer) {
      const dateTimeFormat = this.dateTimeFormat || 'M/D/YYYY hh:mm A'
      const a = moment(reference, dateTimeFormat)
      const b = moment(comparer, dateTimeFormat)
      return a.valueOf() - b.valueOf()
    },
    actionBegin: function (args) {
      if (args.requestType === 'filtering' || args.requestType === 'refresh' || args.requestType === 'paging') {
        this.formatPagination()
      }
    },
    actionComplete: function (args) {
      if (args.action === 'clearFilter' || args.action === 'clear-filter' || args.action === 'filter') {
        this.colorFilteredColumns()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  border-bottom: none;
}
.nav-item {
  margin-bottom: 20px;
  .divider {
    margin: 0 8px;
  }
  a {
    color: $blue-dark;
    text-decoration: none;
    &:hover {
      cursor: pointer;
    }
    &.active {
      text-decoration: underline;
    }
  }
}
.spacing {
  margin-right: 28px;
}
small, .small {
  font-size: 1.4rem;
}
.icon--gray {
  color: #999;
}
</style>
